const SET_CHANGING = (state, payload) => {
  state.changing = payload
}

const SET_FILTER = (state, payload) => {
  const columnIdx = state.filters.findIndex(x => x.columnId === payload.columnId)

  if (columnIdx === -1) {
    state.filters.push({
      showEmpty: false,
      filter: [payload.valueId],
      columnId: payload.columnId
    })
  } else {
    const entry = state.filters[columnIdx]
    const idx = state.filters[columnIdx].filter.findIndex(x => x === payload.valueId)

    if (idx !== -1) {
      entry.filter.splice(idx, 1)

      if (!entry.showEmpty && entry.filter.length === 0) state.filters.splice(columnIdx, 1)
    } else {
      entry.filter.push(payload.valueId)
    }
  }
}

const TOGGLE_EMPTY = (state, columnId) => {
  const columnIdx = state.filters.findIndex(x => x.columnId === columnId)

  if (columnIdx === -1) {
    state.filters.push({
      showEmpty: true,
      filter: [],
      columnId: columnId
    })
  } else {
    const entry = state.filters[columnIdx]

    entry.showEmpty = !entry.showEmpty

    if (!entry.showEmpty && entry.filter.length === 0) state.filters.splice(columnIdx, 1)
  }
}

const RESET_FILTER = (state, columnId) => {
  const idx = state.filters.findIndex(x => x.columnId === columnId)

  state.filters.splice(idx, 1)
}

export default {
  SET_CHANGING,
  SET_FILTER,
  TOGGLE_EMPTY,
  RESET_FILTER
}
